module.exports = __webpack_public_path__ + "media/images/logo-d04b2946.png";